<script setup>
import { ref } from 'vue';
import Accordions from '@/components/accordions/Accordions.vue';

const props = defineProps({
    data: { type: Object, default: () => {} },
    themeColor: {
        type: String,
        default: '',
    },
    color: {
        type: String,
        default: '',
    },
});

const elref = ref(null);
const childrenList = ref([]);
const hasSpace = ref(props.space);
if (props.data.data.fullWidth) {
    hasSpace.value = false;
}

for (let i = 0, il = props.data.data.children.length; i < il; ++i) {
    const section = props.data.data.children[i];
    childrenList.value.push({
        question: section.featuredContentTitle,
        wysiwyg: section.flexibleWysiwig,
    });
}
</script>

<template>
    <div
        ref="elref"
        class="AccordionsFlexible Page__right"
    >
        <Accordions
            :title="data.data.featuredContentTitle"
            :sections="childrenList"
            :parent-element="elref"
            :color="color"
            :theme-color="themeColor"
        />
    </div>
</template>
